import Login from "../page/login/Login";
import AuthConsumer from "../../../context/auth/AuthConsumer";

export default function LoginHOC({ ...props }) {
  return (
    <AuthConsumer>
      {({ ...rest }) => {
        return <Login {...props} {...rest} />
      }}
    </AuthConsumer>
  );
}
